import { render, staticRenderFns } from "./wasteproductionTable.vue?vue&type=template&id=bac00680&scoped=true&"
import script from "./wasteproductionTable.vue?vue&type=script&lang=js&"
export * from "./wasteproductionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac00680",
  null
  
)

export default component.exports